<template>
  <div>
   
      <v-layout>
                <v-flex xs12 sm6 offset-sm3>

 <h1>OData Demo</h1>
 <br>
                    Enter  S/4 Matrialnumber. (Pls. make sure, that your browser is not checking CORS.)

                    <v-form class="mt-3">

                        <v-text-field v-model="matnr"
                                      label="S/4 Materialnumber"
                                      outline
                                      clearable
                                      required></v-text-field>
                    </v-form>

                    <v-btn small color="primary" v-on:click="ui_event('getPrice')">
                        Get Price from S4
                    </v-btn>
                  <br>
                   <div v-for="line in lines" :key="line">
                      {{line}}
                    </div>
                </v-flex>
            </v-layout> <!-- Access Code Form -->



  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import { FirebaseTable } from "../table/FirebaseTable.js";
import { create_moodle_xml } from "../quiz/Moodle.js";
import axios from "axios";

export default {
  data() {
    return {
      components: {},
      matnr: "DXTR3999",
      VKORG: "",
      VTWEG: "",
      CUR: "",
      KBETR: "",
      baseUrl: process.env.BASE_URL,
      fbTable: {},

      ui_show_odata: false,

      lines: [],
    };
  },

  computed: {
    userName() {
      console.log("Store call back");
      return this.$store.state.currentUser;
    },
  },

  methods: {

    async ui_event(event) {
       let config = {
            headers: {
              "content-type": "application/json",
            },
            auth: {
              username: "bv_master",
              password: "maihiro",
            },
          };

      switch (event) {
        case "getPrice":
          this.lines = ["\n ", "Response:"];
          var h_url =
            "https://xxxxxxxx.de/sap/opu/odata/sap/ZBV_TEST_SRV/PRICESet('" +
            this.matnr +
            "')";
         this.lines = [];
         this.lines.push("Request : " + h_url);
         this.lines.push("-");
         this.lines.push("Response:");
                    
         var url =
            "https://r36z.ucc.ovgu.de/sap/opu/odata/sap/ZBV_TEST_SRV/PRICESet('" +
            this.matnr +
            "')";
          console.log(url);

         

          axios
            .get(url, config)
            .then((R) => {
              console.log("Intent / Response : ");
              this.VKORG = R.data.d.VKORG;
              this.VTWEG = R.data.d.VTWEG;
              this.KONWA = R.data.d.KONWA;
              this.KBETR = R.data.d.KBETR;
              this.RETURN_CODE = R.data.d.RETURN_CODE;

              if (this.RETURN_CODE != "S") {
                this.lines.push("    >> Error in request : ", this.RETURN_CODE);
              } else {
                this.lines.push("Sales Organization : " + this.VKORG);
                this.lines.push("Distribution Channel : " + this.VTWEG);
                this.lines.push("Currency   : " + this.KONWA);
                this.lines.push("Price : " + this.KBETR);
              }
            })
            .catch((error) => {
              console.log("Error : " + JSON.stringify(error));
            });

          return;

        case "Test 1": // return to landing page
          // r = this.fbTable.create_test_table( )
          //r =  await this.fbTable.get_lines( tName)

          //var x = await this.fbTable.get_count(tName);
          //r = await this.fbTable.set_count(tName);
          this.list_sap_entries();
          return;

        

        case "cancel": // return to landing page
          this.$router.push({ name: "Landing" });
          return;
      }
    },
  },

  beforeCreate() {
    console.log("Lifecycle Hook: before create");
  },

  created() {
    console.log("Lifecycle Hook: created");
    this.fbTable = new FirebaseTable();
  },

  beforeMount() {
    console.log("Lifecycle Hook: beforeMount");
  },

  mounted() {
    this.fbTable = new FirebaseTable("Test1");
  },

  beforeUpdate() {
    console.log("Lifecycle Hook: beforeUpdate");
  },

  beforeDestroy() {
    console.log("Lifecycle Hook: beforeDestroy");
  },

  // Router Links
  // https://router.vuejs.org/guide/advanced/navigation-guards.html#in-component-guards
  beforeRouteEnter(to, from, next) {
    console.log("Router Hook: before route enter");
  },

  beforeRouteUpdate(to, from, next) {
    console.log("Router Hook: before route update");
  },

  beforeRouteLeave(to, from, next) {
    console.log("Router Hook: before route leave");
  },
};
</script>

<style scoped>
</style>
